import { EventEmitter } from 'events';

import Echo from 'laravel-echo';
import React from 'react';

window.Pusher = require('pusher-js')

class Sockets extends EventEmitter {
    /**
     * @var echo
     * @type {null}
     */
    echo = null;

    /**
     * @var connected
     * @type {boolean}
     */
    connected = false;

    /**
     * @var hasBeenConnected
     * @type {boolean}
     */
    hasBeenConnected = false;

    /**
     * @method getConnection
     * @return {Echo}
     */
    getConnection = () => {
        if (this.echo === null && typeof Pusher !== 'undefined') {
            if (process.env.MIX_ECHO_DRIVER === 'soketi') {
                this.echo = new Echo({
                    broadcaster: 'pusher',
                    key: process.env.MIX_PUSHER_APP_KEY,
                    wsHost: process.env.MIX_PUSHER_HOST,
                    wsPort: process.env.MIX_PUSHER_PORT,
                    wssPort: process.env.MIX_PUSHER_PORT,
                    forceTLS: process.env.MIX_PUSHER_SCHEME === 'https',
                    encrypted: true,
                    disableStats: true,
                    enabledTransports: ['ws', 'wss'],
                    cluster: process.env.MIX_PUSHER_APP_CLUSTER
                });

                this.handleSoketiConnectionEvents();
            }

            // After we first attempt to connect leave it 5 seconds and check if first connected.
            setTimeout(() => this.checkIfConnected(), 5000);
        }

        return this.echo;
    };

    /**
     * @method checkIfConnected
     */
    checkIfConnected = () => {
        if (process.env.MIX_ECHO_DRIVER === 'soketi') {
            this.handleSoketiConnectionEvents();
        }
    }

    /**
     * @method handleSoketiConnectionEvents
     */
    handleSoketiConnectionEvents = () => {
        this.echo.connector.pusher.connection.bind('connected', () => {
            this.handleConnectedChange(true);
        });

        this.echo.connector.pusher.connection.bind('disconnected', () => {
            this.handleConnectedChange(false);
        });

        this.echo.connector.pusher.connection.bind('unavailable', () => {
            this.handleConnectedChange(false);
        });

        this.echo.connector.pusher.connection.bind('failed', () => {
            this.handleConnectedChange(false);
        });
    }

    /**
     * @method handleConnectedChange
     */
    handleConnectedChange = (connected) => {
        if (connected) {
            this.connected = true;
            this.hasBeenConnected = true;
        } else {
            this.connected = false;
        }

        this.emit('change');
    }

    /**
     * @method connect
     * @param id
     * @returns {*}
     */
    connect = (id) => {
        this.getConnection();

        this.channelName = `App.User.${id}`;

        return this.channel = this.echo?.private(this.channelName);
    };

    /**
     * @method getChannel
     * @return {null}
     */
    getChannel = () => {
        return this.channel;
    };

    /**
     * @method notification
     * @param {Function} callback
     */
    notification = (callback) => {
        this.getChannel()?.notification((data) => {
            if (callback !== undefined) {
                callback(data);
            }
        });
    };

    /**
     * @method listen
     * @param {string} event
     * @param {Function} callback
     */
    listen = (event, callback) => {
        this.getChannel()?.listen(event, callback);
    };

    stopListening = (event) => {
        this.getChannel()?.stopListening(event);
    };
}

export default new Sockets();
